module.exports = {"Positions":"سمت ها","PersonnelId":"کد پرسنلی"}